import { isWithinInterval, isBefore, subDays } from 'date-fns';

import { Notification, NotificationEdge } from '@/types/graphql';

export interface INotificationsGroup {
  dividerTitle: string;
  items: Notification[];
}

interface IInterval {
  key: string;
  dividerTitle: string;
  isWithin(date: Date): boolean;
}

export const groupNotificationsByDateDividers = (edges: Array<NotificationEdge>) => {
  const today = new Date();
  const yesterday = subDays(today, 1);
  const sevenDaysAgo = subDays(today, 7);

  const intervals: Array<IInterval> = [
    {
      isWithin(date: Date) {
        return isWithinInterval(date, {
          start: yesterday,
          end: today,
        });
      },

      dividerTitle: 'Today',
      key: 'today',
    },
    {
      isWithin(date: Date) {
        return isWithinInterval(date, {
          start: sevenDaysAgo,
          end: yesterday,
        });
      },
      dividerTitle: 'This Week',
      key: 'thisWeek',
    },
    {
      isWithin(date: Date) {
        return isBefore(date, sevenDaysAgo);
      },
      dividerTitle: 'Earlier',
      key: 'earlier',
    },
  ];

  return edges.reduce((acc: Record<string, INotificationsGroup>, edge: NotificationEdge) => {
    const { node } = edge;
    if (!node) return acc;

    const nodeDate = new Date(node.createdAt);
    const group = intervals.find(({ isWithin }) => isWithin(nodeDate));
    if (!group) return acc;

    acc[group.key] = acc[group.key] || {
      dividerTitle: group.dividerTitle,
      items: [],
    };

    acc[group.key].items.push(node as Notification);

    return acc;
  }, {});
};
